/* eslint-disable no-nested-ternary */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import capitalize from "lodash-es/capitalize";
let WButton = class WButton extends Vue {
  constructor() {
    super(...arguments);
    this.selfLoading = false;
  }
  get buttonClass() {
    let btnClass = 'uc-button';
    if (this.type !== 'normal') btnClass += ` is${capitalize(this.type)}`;
    if (this.size !== 'default') btnClass += ` is${capitalize(this.size)}`;
    if (this.disabled) btnClass += ' isDisabled';
    return btnClass;
  }
  get finalLoading() {
    return !!(this.loading || this.selfLoading);
  }
  setLoading(loading) {
    this.selfLoading = !!loading;
  }
  handleClick(event) {
    event.preventDefault();
    if (this.finalLoading || this.disabled) return;
    this.$emit('click', event);
    if (typeof this.onClick === 'function') {
      this.setLoading(true);
      Promise.resolve().then(this.onClick).catch(err => {
        console.error('[UICore] 按钮点击事件中出错：', err, this);
      }).then(() => {
        this.setLoading(false);
      });
    }
  }
  render() {
    const h = arguments[0];
    return h("button", {
      "on": {
        "click": this.handleClick
      },
      "class": this.buttonClass,
      "attrs": {
        "disabled": !!this.disabled
      }
    }, [this.finalLoading ? h("i", {
      "class": "fa fa-spinner uc-anim-rotating"
    }) : this.icon ? h("i", {
      "class": `fa fa-${this.icon}`
    }) : null, this.$slots.default || this.title]);
  }
};
__decorate([Prop({
  type: String,
  default: ''
})], WButton.prototype, "title", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], WButton.prototype, "icon", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], WButton.prototype, "disabled", void 0);
__decorate([Prop({
  default: 'normal',
  type: String
})], WButton.prototype, "type", void 0);
__decorate([Prop({
  default: 'default',
  type: String
})], WButton.prototype, "size", void 0);
__decorate([Prop({
  default: false,
  type: Boolean
})], WButton.prototype, "loading", void 0);
__decorate([Prop({
  type: Function
})], WButton.prototype, "onClick", void 0);
WButton = __decorate([Component({
  name: 'WButton'
})], WButton);
export default WButton;
//# sourceMappingURL=index.js.map
